<template lang="pug">
  .container(id="HolidaysetList-container")
    el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll
      el-header(height='40px') {{$t('Play Period Set list')}}
        el-button.el-button--mini.float-right(
          type='success',
          id="HolidaysetList-addButton",
          icon='el-icon-plus',
          @click='handleAdd()'
        )
      .row.header
        .cell.dateset.header
          .name {{ $t('Set') }}
          el-input.input(v-model='nameSearch', id="HolidaysetList-searchInput", size='mini', type='text', clearable)
        .cell.periods.header
          .name {{ $t('# Periods') }}
        .cell.buttons.header {{ $t('') }}
      .row(v-for="holidayset of holidaysets()", :id="'HolidaysetList-row' + holidayset.id", :key='holidayset.id')
        .cell.dateset {{ holidayset.name }}
        .cell.periods {{ holidayset.HolidayPeriods.length }}
        .cell.buttons
          el-button-group
            el-button(
              type="success",
              @click="handleEdit(holidayset)",
              :title="$t('Edit datetime set')",
              :id="'HolidaysetList-editButton' + holidayset.id",
              size="mini"
            )
              font-awesome-icon.float-right.button(icon="edit")
            el-button(
              type="success",
              @click="handleDelete(holidayset)",
              :title="$t('Delete datetime set')",
              size="mini",
              :id="'HolidaysetList-deleteButton' + holidayset.id",
              v-if='holidayset.HolidayPeriods.length === 0'
            )
              font-awesome-icon.float-right.button(icon="trash")
    HolidaysetEdit(:holidaySetId="editedHolidaySetId", :editDialogVisible="editDialogVisible", @closeEditDialog="handleCloseEditDialog()")
</template>

<script>
import HolidaysetEdit from './HolidaysetEdit'

export default {
  props: ['side'],
  components: { HolidaysetEdit },
  created () {
    this.$store.dispatch('Holidayset/getList')
  },
  data () {
    return {
      errors: {},
      editDialogVisible: false,
      editedHolidaySetId: undefined,
      nameSearch: ''
    }
  },
  methods: {
    handleAdd () {
      this.editedHolidaySetId = 0
      this.editDialogVisible = true
    },
    handleEdit (holidaySet) {
      console.error(holidaySet)
      this.editedHolidaySetId = holidaySet.id
      this.editDialogVisible = true
    },
    async handleDelete (holidaySet) {
      await this.$store.dispatch('Holidayset/deleteHolidaySet', holidaySet)
      await this.$store.dispatch('Holidayset/getList')
      this.holidaysets()
    },
    // FIXME DRY
    handleCloseEditDialog (result) {
      this.editedHolidaySetId = null
      this.editDialogVisible = false
    },
    holidaysets () {
      let holidaysetsFiltered = JSON.parse(JSON.stringify(this.$store.state.Holidayset.holidayset_list))
      holidaysetsFiltered = this.nameSearch !== '' ? holidaysetsFiltered.filter(dts => dts.name.toLowerCase().indexOf(this.nameSearch.toLowerCase()) > -1) : holidaysetsFiltered
      return holidaysetsFiltered.sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.row {
  display: flex;
  font-size: $--font-size-base;
  padding: 10px 0px;
  &.header {
    color: $--color-text-secondary;
  }
  .cell {
    width: calc((100% - 25px - 110px)/2);
    border-bottom: $--border-light;
    &.header {
      display: flex;
      align-items: center;
      justify-content: left;
      border-bottom: 2px solid $--color-primary;
      margin-bottom: 15px;
      padding-bottom: 15p 25px;
    }
    &.buttons {
      text-align: right;
      // width: 110px;
    }
    &.dateset {
      width: 40%;
    }
    .name {
      margin-right: 15px;
    }
    .input {
      max-width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Holidayset/List.vue